import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { apiOrganization } from "../../../../../../../../../../../services/Api/Organization/apiOrganization";
import { InvoiceApi, TaxApi } from "../../../../../../../../../../../services/Api/Organization/types";
import InvoiceFormItemsTableBody from "./InvoiceFormItemsTableBody";
import InvoiceFormItemsTableHeader from "./InvoiceFormItemsTableHeader";

interface Props {
	form: UseFormReturn<InvoiceApi>;
	taxes: TaxApi[];
}

const InvoiceFormItemsTable = ({ form, taxes }: Props) => {
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;

	const searchProducts = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		const newParams = {
			...params,
			"statuses|e": "ENABLED",
		};
		return apiOrganization.getProductSearchSelect(search, newParams, {
			cancelToken: options?.token,
		});
	};

	return (
		<fieldset className="form-group">
			<h5 className={isMobile ? "mb-0" : ""}>{t("common.word.items")}</h5>
			<div className={`${isMobile ? "table-responsive" : ""}`}>
				<table
					className={`table table-form positions-table positions-table--small ${
						isMobile ? "vertical-top" : ""
					}`}
				>
					<InvoiceFormItemsTableHeader form={form} />
					<InvoiceFormItemsTableBody form={form} searchProducts={searchProducts} taxes={taxes} />
				</table>
			</div>
		</fieldset>
	);
};

export default InvoiceFormItemsTable;
